import React from "react"
import styled from "styled-components"
import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import { setColor, setRem, media } from "../../style"
import { FormattedMessage, FormattedHTMLMessage } from "gatsby-plugin-intl"

const MailingList = () => {
  const emailAddress = <FormattedMessage id="global.MailingList.emailAddress" />
  return (
    <Container>
      <div className="left-text">
        <FormattedHTMLMessage id="global.MailingList.singUp" />
      </div>
      <TextField
        name="email"
        type="email"
        variant="filled"
        color="secondary"
        label={emailAddress}
        size="small"
        required
        
      />
      <Button className="button" variant="outlined" color="secondary" size="large">
        <FormattedMessage id="global.MailingList.send" />
        
      </Button>
    </Container>
  )
}

export default MailingList

const Container = styled.form`
  padding: 0 1rem 1.2rem;
  display: grid;
  grid-template-columns: 3fr 2fr 1fr;
  grid-column-gap: 0.8rem;
  align-items: center;
  color: ${setColor.lightGrey};
  b {
    color: ${setColor.primaryColor};
  }
  .left-text {
      place-self: center;
      font-size: ${setRem(15)};
      font-weight: bold;
      color: #A0A09F;

  }


  .button {
    text-transform: capitalize;
    border-radius: 0px;
    height: 47px;
  }
  .MuiTextField-root {
    background-color: #F14773BF;
    color: ${setColor.mainWhite};
  }

  .MuiInputLabel-formControl {
    color: white;
    font-size: ${setRem(10)};
    ${media.tablet`
    font-size: ${setRem(16)};
    `}
  }
`
